import React, { useState } from "react";
import { PropertyService } from "../../services/property";
import { formatDate } from "ultils/date-formatter";

interface PropertyDetailsProps {
  propertyDetails: any; // Passed prop containing property details
  onPropertyUpdate: (updatedDetails: any) => void; // Callback for parent to handle updates
}

const PropertyDetails: React.FC<PropertyDetailsProps> = ({
  propertyDetails,
  onPropertyUpdate,
}) => {
  const [updatedPropertyDetails, setPropertyDetails] = useState(
    propertyDetails || {}
  );

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      console.log(updatedPropertyDetails);
      await PropertyService.updateProperty(updatedPropertyDetails);
      onPropertyUpdate(updatedPropertyDetails); // Notify the parent component of the updated details
      // alert("Property details updated successfully");
    } catch (err) {
      console.error("Failed to update property:", err);
      alert("Failed to update property details");
    }
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value, type } = e.target;
    const isCheckbox = type === "checkbox";

    setPropertyDetails({
      ...updatedPropertyDetails,
      [name]: isCheckbox ? (e.target as HTMLInputElement).checked : value,
    });
  };

  return (
    <div className="">
      <div
        className={`add-property-container ${
          propertyDetails.isRented ? "rented-border" : ""
        }`}
      >
        <h1>Property Details</h1>
        <form onSubmit={handleSubmit} className="add-property-form">
          {/* Street Address */}
          <div className="form-group">
            <label htmlFor="streetAddress">Street Address:</label>
            <input
              type="text"
              id="streetAddress"
              name="streetAddress"
              value={updatedPropertyDetails?.streetAddress || ""}
              onChange={handleChange}
              required
              placeholder="Enter street address"
            />
          </div>
          {/* City, State, and Zip Code on One Row */}
          <div className="form-group address-row">
            <div className="address-field">
              <label htmlFor="city">City:</label>
              <input
                type="text"
                id="city"
                name="city"
                value={updatedPropertyDetails?.city || ""}
                onChange={handleChange}
                required
                placeholder="Enter city"
              />
            </div>

            <div className="address-field">
              <label htmlFor="state">State:</label>
              <input
                type="text"
                id="state"
                name="state"
                value={updatedPropertyDetails?.state || ""}
                onChange={handleChange}
                required
                placeholder="Enter state"
              />
            </div>

            <div className="address-field">
              <label htmlFor="zipCode">Zip Code:</label>
              <input
                type="number"
                id="zipCode"
                name="zipCode"
                value={updatedPropertyDetails?.zipCode || ""}
                onChange={handleChange}
                required
                placeholder="Enter zip code"
              />
            </div>
          </div>

          {/* Purchase Price */}

          <div className="form-group purchase-row">
            <div className="address-field">
              <label htmlFor="purchasePrice">Purchase Price:</label>
              <input
                type="number"
                id="purchasePrice"
                name="purchasePrice"
                value={updatedPropertyDetails?.purchasePrice || ""}
                onChange={handleChange}
                required
                placeholder="Enter purchase price"
              />
            </div>

            <div className="address-field">
              <label htmlFor="purchasePrice">Purchase Date:</label>
              <input
                type="date"
                id="purchaseDate"
                name="purchaseDate"
                value={
                  formatDate(
                    new Date(updatedPropertyDetails?.purchaseDate),
                    "yyyy-MM-dd"
                  ) || ""
                }
                onChange={handleChange}
                required
                placeholder="Enter purchase date"
              />
            </div>
          </div>

          {/* Multi-Family Checkbox */}
          <div className="form-group" style={{ display: "inline" }}>
            <label>
              <input
                type="checkbox"
                name="isMultiFamily"
                checked={updatedPropertyDetails?.isMultiFamily || false}
                onChange={handleChange}
              />
              Is this a multi-family property?
            </label>
          </div>

          {/* Units */}
          {propertyDetails.isMultiFamily && (
            <div className="form-group">
              <label htmlFor="units">Number of Units:</label>
              <input
                type="number"
                id="units"
                name="units"
                value={updatedPropertyDetails?.numOfUnits || ""}
                onChange={handleChange}
                min="1"
                required
              />
            </div>
          )}

          <div className="form-group" style={{ display: "inline" }}>
            <label>
              <input
                type="checkbox"
                name="isRented"
                checked={updatedPropertyDetails?.isRented || false}
                onChange={handleChange}
              />
              Is this a rented property?
            </label>
          </div>

          <div className="form-group rent-row">
            <div className="form-group">
              <label htmlFor="actualRent">Actual Rent:</label>
              <input
                type="number"
                id="actualRent"
                name="actualRent"
                disabled={updatedPropertyDetails?.isMultiFamily || false}
                value={updatedPropertyDetails?.actualRent}
                onChange={handleChange}
                required
                placeholder="Actual Rent"
              />
            </div>

            {updatedPropertyDetails.isRented && (
              <div className="form-group">
                <label htmlFor="desiredRent">Desired Rent:</label>
                <input
                  type="number"
                  id="desiredRent"
                  name="desiredRent"
                  value={updatedPropertyDetails?.desiredRent}
                  onChange={handleChange}
                  required
                  placeholder="Desired rent"
                />
              </div>
            )}

            {updatedPropertyDetails.isRented && (
              <div className="form-group">
                <label htmlFor="rentKept">Rent Kept:</label>
                <input
                  type="number"
                  id="rentKept"
                  name="rentKept"
                  value={updatedPropertyDetails?.rentKept}
                  onChange={handleChange}
                  required
                  placeholder="Kept Rent"
                />
              </div>
            )}
          </div>

          {/* Description */}
          <div className="form-group">
            <label htmlFor="description">Description:</label>
            <textarea
              id="description"
              name="description"
              value={updatedPropertyDetails?.description || ""}
              onChange={handleChange}
              placeholder="Enter additional details about the property"
            />
          </div>

          <button type="submit" className="submit-button">
            Update Property
          </button>
        </form>
        <p>
          Last modifed by{" "}
          {propertyDetails.modifiedBy +
            " on " +
            formatDate(propertyDetails.dateModified, "MMMM dd, yyyy")}
        </p>
      </div>
      {/* <TenantDetails  /> */}
    </div>
  );
};

export default PropertyDetails;
